<template>
    <div class="box1">
        <div class="loader1"></div>
    </div>
</template>
<script>
    export default {
        name: 'niceLoader',
    }
</script>
<style>
    .box1{
        width: 100%;
        height: 100vh;
        position: fixed;
        background-color: #0000003b;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loader1 {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #505050;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
    }
</style>